import { createFileRoute } from '@tanstack/react-router'
import { PalletSizeEditor } from './-PalletSizeEditor'

export const Route = createFileRoute('/settings/pallet-sizes/$id')({
  component: EditPalletSizePage,
})

function EditPalletSizePage() {
  const { id } = Route.useParams()
  return <PalletSizeEditor id={id} />
}
